export const SET_SEARCHOBJ = 'SET_SEARCHOBJ'
export const SET_NEWADDRESS = 'SET_NEWADDRESS'
export const SET_AREACODE = 'SET_AREACODE'
export const SET_USERINFO = 'SET_USERINFO'
export const SET_AVATAR = 'SET_AVATAR'
export const SET_CURRENTPRO = 'SET_CURRENTPRO'
export const SET_SHOPPINGCART = 'SET_SHOPPINGCART'
export const SET_CARTNUMBER = 'SET_CARTNUMBER'
export const SET_NOTICEID = 'SET_NOTICEID'
export const SET_COLLECTDATA = 'SET_COLLECTDATA'
export const SHOW_LOGIN = 'SHOW_LOGIN'
export const IS_LOGIN = 'IS_LOGIN'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js